import { render, staticRenderFns } from "./health-check.vue?vue&type=template&id=1b399d26&scoped=true&"
import script from "./health-check.vue?vue&type=script&lang=ts&"
export * from "./health-check.vue?vue&type=script&lang=ts&"
import style0 from "./health-check.vue?vue&type=style&index=0&id=1b399d26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b399d26",
  null
  
)

export default component.exports